/**
 * Brandner Auktions-Zentrale JavaScript
 *
 * - Tab-Wechsel ohne Seiten-Neuladen
 * - Sortierung der Auktionslisten (Optionen + Comparator wie Artikeluebersicht)
 * - Synchronisation mit Galerie-JS (brandner-custom.php)
 *
 * Timer und Bid-Form werden von brandner-custom.php gesteuert
 * (gleiche .brandner-auction-card-bid Struktur wie Galerie).
 *
 * @package Brandner_Custom
 * @since 1.3.0
 */

(function($) {
    'use strict';

    // Konfiguration aus PHP
    var config = window.brandnerAuctionCenter || {
        ajaxUrl: '/wp-admin/admin-ajax.php',
        currentUserId: 0,
        pollInterval: 5000,
        nonce: ''
    };

    // State
    var state = {
        isPolling: false,
        pollTimer: null,
        activeTab: 'bids',
        galerieSyncTimer: null
    };

    /**
     * Initialize Auction Center
     */
    function init() {
        var $container = $('.auction-center--redesign');
        if (!$container.length) return;

        // Aktiven Tab aus URL oder DOM ermitteln
        var urlParams = new URLSearchParams(window.location.search);
        var tabFromUrl = urlParams.get('tab');
        if (tabFromUrl && ['bids', 'watchlist', 'ended'].indexOf(tabFromUrl) !== -1) {
            state.activeTab = tabFromUrl;
        } else {
            var $activePanel = $container.find('.auction-center__panel--active');
            if ($activePanel.length) {
                state.activeTab = $activePanel.data('panel');
            }
        }

        // Tab-Klick-Handler
        initTabNavigation($container);

        // Sortier-Dropdowns (Gebotsliste, Beobachtungen)
        initSortControls($container);

        // Dropdown z-index Handler
        initDropdownHandler();

        // Synchronisation mit Galerie-JS
        initGalerieSync();

        // Polling starten fuer aktive Auktionen
        startPolling();

        // Visibility Change Handler
        document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    /**
     * Initialize tab navigation (JS-based, no page reload)
     */
    function initTabNavigation($container) {
        $container.on('click', '.auction-center__tab', function(e) {
            e.preventDefault();

            var $tab = $(this);
            var targetPanel = $tab.data('tab');

            if (targetPanel === state.activeTab) return;

            // Tabs deaktivieren/aktivieren
            $container.find('.auction-center__tab').removeClass('auction-center__tab--active')
                .attr('aria-selected', 'false');
            $tab.addClass('auction-center__tab--active').attr('aria-selected', 'true');

            // Panels verstecken/zeigen
            $container.find('.auction-center__panel').hide()
                .removeClass('auction-center__panel--active');
            $container.find('[data-panel="' + targetPanel + '"]').show()
                .addClass('auction-center__panel--active');

            // State aktualisieren
            state.activeTab = targetPanel;

            // URL ohne Reload aktualisieren (optional, fuer Bookmarking)
            var newUrl = new URL(window.location.href);
            newUrl.searchParams.set('tab', targetPanel);
            history.pushState({ tab: targetPanel }, '', newUrl);
        });

        // Browser-Zurueck-Button Handler
        window.addEventListener('popstate', function(e) {
            // PJAX-Events ignorieren (werden vom PJAX-Controller behandelt)
            if (e.state && e.state.pjax) return;

            if (e.state && e.state.tab) {
                var $tab = $container.find('[data-tab="' + e.state.tab + '"]');
                if ($tab.length) {
                    $tab.trigger('click');
                }
            }
        });
    }

    // =========================================================================
    // SORTIERUNG — Optionen und Comparator 1:1 wie die Artikeluebersicht
    // (templates/taxonomy-auction-project.php + assets/js/project-sort.js)
    // =========================================================================

    var SORT_STORAGE_KEY = 'brandnerAuctionCenterSort';
    var SORT_DEFAULT = 'end_date-asc'; // entspricht der serverseitigen Reihenfolge

    /**
     * Gespeicherte Sortier-Praeferenzen je Tab lesen ({bids: 'end_date-asc', ...})
     */
    function readSortPrefs() {
        try {
            var raw = window.localStorage.getItem(SORT_STORAGE_KEY);
            var parsed = raw ? JSON.parse(raw) : null;
            return (parsed && typeof parsed === 'object') ? parsed : {};
        } catch (e) {
            return {};
        }
    }

    /**
     * Sortier-Praeferenz fuer einen Tab speichern
     */
    function saveSortPref(panel, mode) {
        try {
            var prefs = readSortPrefs();
            prefs[panel] = mode;
            window.localStorage.setItem(SORT_STORAGE_KEY, JSON.stringify(prefs));
        } catch (e) {
            // localStorage nicht verfuegbar (z. B. Privatmodus) - Sortierung gilt nur fuer diese Ansicht
        }
    }

    /**
     * Produkt-ID einer Loskarte ermitteln (Bid-Card, Fallback: post-<id> Klasse)
     */
    function getCardProductId($li) {
        var id = parseInt($li.find('.brandner-auction-card-bid').first().attr('data-product-id'), 10);
        if (!id) {
            var match = /(?:^|\s)post-(\d+)(?:\s|$)/.exec($li.attr('class') || '');
            id = match ? parseInt(match[1], 10) : 0;
        }
        return id || 0;
    }

    /**
     * Sortierdaten einer Loskarte: Server-JSON (data-auction-sort auf ul.products)
     * plus Live-Werte der Karte (aktuelles Gebot, Gebotsanzahl, beendet), die das
     * Polling laufend aktualisiert.
     */
    function getCardSortData($li, sortMap) {
        var id = getCardProductId($li);
        var data = $.extend({}, sortMap[id] || {});
        var $bidCard = $li.find('.brandner-auction-card-bid').first();

        if ($bidCard.length) {
            var liveBid = parseFloat($bidCard.attr('data-current-bid'));
            if (!isNaN(liveBid)) data.current_bid = liveBid;

            var $count = $li.find('.meta-bids-count').first();
            if ($count.length) {
                var liveCount = parseInt($count.text(), 10);
                if (!isNaN(liveCount)) data.bid_count = liveCount;
            }

            if ($bidCard.hasClass('ended') || $bidCard.attr('data-ended') === '1') {
                data.is_ended = true;
            }
        }

        return data;
    }

    /**
     * Comparator fuer eine Sortier-Auswahl ("feld-richtung") — identisch zu
     * makeComparator() in project-sort.js und zur PHP-Sortierung der Projektseite.
     */
    function makeSortComparator(sortValue) {
        var parts = String(sortValue).split('-');
        var field = parts[0];  // end_date, current_bid, lowest_price, sku, bid_count
        var order = parts[1] === 'desc' ? 'desc' : 'asc';

        return function(a, b) {
            var dataA = a.data;
            var dataB = b.data;

            // Beendete Auktionen immer ans Ende (bei end_date + current_bid Sortierung)
            if (field === 'end_date' || field === 'current_bid') {
                var endedA = !!dataA.is_ended;
                var endedB = !!dataB.is_ended;
                if (endedA && !endedB) return 1;
                if (!endedA && endedB) return -1;
            }

            var valA, valB;
            if (field === 'sku') {
                valA = parseInt(dataA.lot_number, 10) || 0;
                valB = parseInt(dataB.lot_number, 10) || 0;
            } else if (field === 'current_bid' || field === 'lowest_price' || field === 'bid_count') {
                valA = parseFloat(dataA[field]) || 0;
                valB = parseFloat(dataB[field]) || 0;
            } else if (field === 'end_date') {
                // Stabil nach geplantem Ende (vor Anti-Snipe), wie Projektseite
                valA = dataA.scheduled_end || dataA.end_date || '';
                valB = dataB.scheduled_end || dataB.end_date || '';
            } else {
                valA = dataA[field] || '';
                valB = dataB[field] || '';
            }

            var result = valA < valB ? -1 : (valA > valB ? 1 : 0);

            // Gleichstand -> Tiebreak ueber die Losnummer (wie Projektseite)
            if (result === 0) {
                var lotA = parseInt(dataA.lot_number, 10) || 0;
                var lotB = parseInt(dataB.lot_number, 10) || 0;
                result = lotA < lotB ? -1 : (lotA > lotB ? 1 : 0);
            }

            return order === 'desc' ? -result : result;
        };
    }

    /**
     * Loskarten eines Panels umsortieren
     *
     * Verschiebt nur DOM-Knoten (Element-Identitaet bleibt erhalten),
     * Timer und Gebots-Handler laufen unveraendert weiter.
     */
    function sortPanel($panel, mode) {
        var $list = $panel.find('ul.products').first();
        if (!$list.length) return;

        var $items = $list.children('li.product');
        if ($items.length < 2) return;

        var sortMap = {};
        try {
            sortMap = JSON.parse($list.attr('data-auction-sort') || '{}') || {};
        } catch (e) {
            sortMap = {};
        }

        var entries = $items.map(function(index, li) {
            return { el: li, data: getCardSortData($(li), sortMap), index: index };
        }).get();

        var compare = makeSortComparator(mode);
        entries.sort(function(a, b) {
            var result = compare(a, b);
            return result !== 0 ? result : (a.index - b.index); // stabil
        });

        var fragment = document.createDocumentFragment();
        entries.forEach(function(entry) {
            fragment.appendChild(entry.el);
        });
        $list[0].appendChild(fragment);
    }

    /**
     * Gueltige Sortier-Werte = Optionen des Dropdowns (eine Quelle: PHP-Optionsliste)
     */
    function getSelectModes($select) {
        return $select.find('option').map(function() { return this.value; }).get();
    }

    /**
     * Sortier-Dropdowns initialisieren: gespeicherte Wahl anwenden, Change-Handler binden
     */
    function initSortControls($container) {
        var prefs = readSortPrefs();

        $container.find('.auction-center__sort-select').each(function() {
            var $select = $(this);
            var panel = $select.data('sortTarget');
            var stored = prefs[panel];

            if (!stored || getSelectModes($select).indexOf(stored) === -1) return;

            $select.val(stored);
            if (stored !== SORT_DEFAULT) {
                sortPanel($container.find('[data-panel="' + panel + '"]'), stored);
            }
        });

        $container.off('change.acSort').on('change.acSort', '.auction-center__sort-select', function() {
            var $select = $(this);
            var panel = $select.data('sortTarget');
            var mode = String($select.val() || SORT_DEFAULT);
            if (getSelectModes($select).indexOf(mode) === -1) mode = SORT_DEFAULT;

            sortPanel($container.find('[data-panel="' + panel + '"]'), mode);
            saveSortPref(panel, mode);
        });
    }

    /**
     * Dropdown z-index Handler
     * Stellt sicher, dass die aeussere .auction-center-card Klasse
     * bei Dropdown-Oeffnung aktualisiert wird.
     */
    function initDropdownHandler() {
        // Bei Oeffnen des Dropdowns auch die aeussere Karte markieren
        $(document).on('click', '.auction-center-card .bid-input-wrapper', function(e) {
            var $outerCard = $(this).closest('.auction-center-card');
            var $bidCard = $(this).closest('.brandner-auction-card-bid');

            // Kurze Verzoegerung damit brandner-custom.php zuerst handeln kann
            setTimeout(function() {
                var isOpen = $bidCard.hasClass('dropdown-open') || $bidCard.find('.bid-dropdown:visible').length > 0;
                $outerCard.toggleClass('dropdown-open', isOpen);
            }, 10);
        });

        // Bei Dropdown-Schliessung auch aeussere Karte aktualisieren
        $(document).on('click', '.auction-center-card .bid-option', function(e) {
            var $outerCard = $(this).closest('.auction-center-card');
            setTimeout(function() {
                $outerCard.removeClass('dropdown-open');
            }, 10);
        });

        // Bei Klick ausserhalb auch aeussere Karte aktualisieren
        $(document).on('click', function(e) {
            if (!$(e.target).closest('.bid-input-group').length) {
                $('.auction-center-card').removeClass('dropdown-open');
            }
        });
    }

    /**
     * Synchronisation mit Galerie-JS
     * Ueberwacht ob brandner-custom.php Auktionen als beendet markiert
     * und aktualisiert die aeussere Karte entsprechend.
     */
    function initGalerieSync() {
        // Alten Timer aufräumen falls vorhanden (PJAX re-init)
        if (state.galerieSyncTimer) clearInterval(state.galerieSyncTimer);

        // Regelmaessig pruefen ob brandner-custom.php Auktionen als beendet markiert hat
        state.galerieSyncTimer = setInterval(function() {
            $('.auction-center-card .brandner-auction-card-bid.ended').each(function() {
                var $bidCard = $(this);
                var $outerCard = $bidCard.closest('.auction-center-card');
                if (!$outerCard.hasClass('auction-center-card--ended')) {
                    $outerCard.addClass('auction-center-card--ended');
                }
            });
        }, 1000);
    }

    /**
     * Start polling for updates
     */
    function startPolling() {
        if (state.isPolling) return;
        if (!config.pollInterval) return;

        state.isPolling = true;
        poll();
    }

    /**
     * Stop polling
     */
    function stopPolling() {
        state.isPolling = false;
        if (state.pollTimer) {
            clearTimeout(state.pollTimer);
            state.pollTimer = null;
        }
    }

    /**
     * Poll for auction updates
     */
    function poll() {
        if (!state.isPolling) return;

        // Nur aktive (nicht beendete) Auktionen sammeln
        var activeIds = [];
        $('.auction-center-card:not(.auction-center-card--ended)').each(function() {
            activeIds.push($(this).data('auction-id'));
        });

        // Duplikate entfernen
        activeIds = [...new Set(activeIds)];

        if (activeIds.length === 0) {
            // Naechsten Poll planen
            state.pollTimer = setTimeout(poll, config.pollInterval);
            return;
        }

        $.ajax({
            url: config.ajaxUrl,
            type: 'POST',
            data: {
                action: 'brandner_get_multiple_auctions',
                product_ids: activeIds.join(',')
            },
            success: function(response) {
                if (response.success && response.data && response.data.auctions) {
                    updateAuctionCards(response.data.auctions);
                }
            },
            complete: function() {
                // Naechsten Poll planen
                if (state.isPolling) {
                    state.pollTimer = setTimeout(poll, config.pollInterval);
                }
            }
        });
    }

    /**
     * Update auction cards with new data
     */
    function updateAuctionCards(data) {
        $.each(data, function(auctionId, auctionData) {
            var $cards = $('.auction-center-card[data-auction-id="' + auctionId + '"]');

            $cards.each(function() {
                var $card = $(this);
                var $bidCard = $card.find('.brandner-auction-card-bid');
                var newBid = parseFloat(auctionData.current_bid) || 0;
                var bidCount = parseInt(auctionData.total_bids, 10) || 0;

                // Preis aktualisieren
                var $priceValue = $card.find('.auction-center-card__price-value');
                if ($priceValue.length) {
                    var oldBid = parseFloat($priceValue.text().replace(/[^\d.,]/g, '').replace('.', '').replace(',', '.')) || 0;
                    if (newBid !== oldBid) {
                        $priceValue.html(formatPrice(newBid));
                        highlightChange($priceValue);
                    }
                }

                // Bid-Count aktualisieren (Meta-Zeile oder Fallback Timer-Bids)
                var $bidCount = $card.find('.meta-bids-count');
                if (!$bidCount.length) $bidCount = $card.find('.timer-bids span');
                if ($bidCount.length) {
                    $bidCount.text(bidCount);
                }

                // Naechstes Mindestgebot aktualisieren (auf .brandner-auction-card-bid)
                if (auctionData.wua_bid_value && $bidCard.length) {
                    $bidCard.attr('data-next-bid', auctionData.wua_bid_value);
                    $bidCard.attr('data-current-bid', newBid);
                    var $input = $bidCard.find('.bid-input');
                    var newNextBid = parseFloat(auctionData.wua_bid_value) || 0;

                    if ($input.length) {
                        // Immer min-Attribut aktualisieren
                        $input.attr('min', auctionData.wua_bid_value);

                        if ($input.hasClass('user-modified')) {
                            // User hat eigenen Wert — nur zuruecksetzen wenn unter neuem Minimum
                            var userValue = parseFloat($input.data('value')) || 0;
                            if (userValue < newNextBid) {
                                $input.removeClass('user-modified');
                                $input.val(auctionData.wua_bid_value);
                                $input.data('value', auctionData.wua_bid_value);
                            }
                        } else {
                            // Kein User-Wert — normal aktualisieren
                            $input.val(auctionData.wua_bid_value);
                            $input.data('value', auctionData.wua_bid_value);
                        }
                    }

                    // Dropdown und Increment via BrandnerRealtime synchronisieren
                    if (window.BrandnerRealtime) {
                        window.BrandnerRealtime.regenerateBidOptions($bidCard, auctionData.wua_bid_value);
                        var newIncrement = window.BrandnerRealtime.getIncrementForPrice(newBid);
                        $bidCard.attr('data-increment', newIncrement);
                    }
                }

                // Timer: BrandnerRealtime.clientTick handles countdown on this page.
                // Do NOT write data-remaining here to avoid oscillation.
            });
        });
    }

    /**
     * Format price (German Euro)
     */
    function formatPrice(amount) {
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
        }).format(amount);
    }

    /**
     * Highlight changed element
     */
    function highlightChange($element) {
        $element.addClass('auction-center-card--updated');
        setTimeout(function() {
            $element.removeClass('auction-center-card--updated');
        }, 2000);
    }

    /**
     * Handle page visibility change
     */
    function handleVisibilityChange() {
        if (document.hidden) {
            stopPolling();
        } else {
            poll();
            startPolling();
        }
    }

    /**
     * Cleanup: Stop polling, remove visibility listener
     */
    function destroy() {
        stopPolling();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        if (state.galerieSyncTimer) {
            clearInterval(state.galerieSyncTimer);
            state.galerieSyncTimer = null;
        }
        // Reset state for re-init
        state.isPolling = false;
        state.pollTimer = null;
    }

    // Expose init/destroy for PJAX
    window.BrandnerAuctionCenterInit = function() {
        // Reset initialized state so init() works again
        init();
    };
    window.BrandnerAuctionCenterDestroy = function() {
        destroy();
    };

    // DOM Ready
    $(document).ready(init);

})(jQuery);
